import { render } from "./set-self-access.vue?vue&type=template&id=25ddedd6&ts=true"
import script from "./set-self-access.vue?vue&type=script&lang=ts"
export * from "./set-self-access.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__